import ToastEditor from '@toast-ui/editor';

const normalizeAiExperiencesLineBreaks = (text: string) => {
  const unixLineBreaks = text.replace(/\r\n?/g, '\n');

  // TODO: Temporary AI-response formatting workaround. Remove once the
  // experiences preview/save pipeline preserves the backend text structure.
  return unixLineBreaks
    .replace(/\n\n(?!\*\*)/g, '\n')
    .replace(/\nSkills:/g, '\n\nSkills:');
};

const normalizeExperiencesText = (text: string): string => {
  if (!text) return '';
  if (/<[a-z][\s\S]*>/i.test(text)) return text;
  const preformattedText = normalizeAiExperiencesLineBreaks(text);

  const el = document.createElement('div');
  const editor = new ToastEditor({
    el,
    initialValue: preformattedText,
    initialEditType: 'wysiwyg',
    hideModeSwitch: true,
    usageStatistics: false,
  });

  editor.setMarkdown(preformattedText, false);
  const html = editor.getHTML();
  editor.destroy();
  return html;
};

export default normalizeExperiencesText;
